<template>
	<button class="v-radio" :checked="checked==value" ref="input" @click="change">
		<div class="v-radio-inner"></div>
		<div class="v-radio-label">
			<v-text>{{label}}</v-text>
			<slot/>
		</div>
	</button>
</template>


<script>
export default {
  model: {
    prop: "selected"
  },
  props: {
    selected: {
      default: null
    },
    value: {
      default: null
    },
    label: {
      default: ""
    }
  },
  computed: {
    hasParent() {
      return this.$parent.$options._componentTag == "v-radio-group";
    },
    checked() {
      return this.hasParent ? this.$parent.selected : this.selected;
    }
  },
  methods: {
    change() {
      if (this.hasParent) {
        this.$parent.selected = this.value;
      } else {
        this.$emit("input", this.value);
        this.$emit("change", this.value);
      }
    }
  }
};
</script>


<style lang="less">
.v-radio {
  border: none;
  padding: 0px;
  outline: none;
  margin: 0px 5px;
  cursor: pointer;
  font-size: inherit;
  white-space: nowrap;
  background-color: #ffffff;
  > .v-radio-inner {
    width: 10px;
    height: 10px;
    padding: 2px;
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;
    border: 2px solid #cccccc;
    &::before {
      content: "";
      width: 100%;
      height: 100%;
      display: block;
      visibility: hidden;
      border-radius: 50%;
      background-color: transparent;
      transform: scale(0);
      transition: 300ms;
    }
  }
  > .v-radio-label {
    display: inline-block;
    vertical-align: middle;
  }
  &[checked] {
    > .v-radio-inner {
      border-color: #41b883;
      &::before {
        transform: scale(1);
        visibility: visible;
        background-color: #41b883;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue-ext/components/radio/index.vue